import React from "react";
import "./collectionIncrease.scss";

//Imagens
import ImgCollectionIncrease from "../../../../assets/publicSector/publicSector.png";
import { useTranslation } from "react-i18next";

function CollectionIncrease() {
  const { t } = useTranslation()

  return (
    <div className="container-collection-increase">
      <div className="img-collection-increase">
        <img src={ImgCollectionIncrease} alt="" />
      </div>
      <div className="texts-collection-increase">
        <h1>{t("public_sector.title")}</h1>
        <p>{t("public_sector.section_text")}</p>
        <a href="/form">
          <button id="btn-collection-increase">{t("buttons.demo_btn_alternative_text_1")}</button>
        </a>
      </div>
    </div>
  );
}

export default CollectionIncrease;
